module.exports = __webpack_public_path__ + "img/full6-min.bc5ed361.png";